/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-time-out.reducer';

export const PreOPTimeOutDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOPTimeOutEntity = useAppSelector(state => state.preOPTimeOut.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOPTimeOutDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOPTimeOut.detail.title">PreOPTimeOut</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.id}</dd>
          <dt>
            <span id="correctPatient">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctPatient">Correct Patient</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.correctPatient ? 'true' : 'false'}</dd>
          <dt>
            <span id="correctSiteAndSide">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctSiteAndSide">Correct Site And Side</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.correctSiteAndSide ? 'true' : 'false'}</dd>
          <dt>
            <span id="correctProcedure">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctProcedure">Correct Procedure</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.correctProcedure ? 'true' : 'false'}</dd>
          <dt>
            <span id="agreementOnProcedure">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.agreementOnProcedure">Agreement On Procedure</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.agreementOnProcedure ? 'true' : 'false'}</dd>
          <dt>
            <span id="correctPatientPosition">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctPatientPosition">Correct Patient Position</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.correctPatientPosition ? 'true' : 'false'}</dd>
          <dt>
            <span id="correctImplantAvailable">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctImplantAvailable">Correct Implant Available</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.correctImplantAvailable ? 'true' : 'false'}</dd>
          <dt>
            <span id="correctEquipmentAvailable">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctEquipmentAvailable">Correct Equipment Available</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.correctEquipmentAvailable ? 'true' : 'false'}</dd>
          <dt>
            <span id="siteMatkingVerified">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.siteMatkingVerified">Site Matking Verified</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.siteMatkingVerified ? 'true' : 'false'}</dd>
          <dt>
            <span id="relevantInvestigationsDone">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.relevantInvestigationsDone">Relevant Investigations Done</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.relevantInvestigationsDone ? 'true' : 'false'}</dd>
          <dt>
            <span id="relevantImagesDone">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.relevantImagesDone">Relevant Images Done</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.relevantImagesDone ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOPTimeOutEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOPTimeOut.surgery">Surgery</Translate>
          </dt>
          <dd>{preOPTimeOutEntity.surgery ? preOPTimeOutEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOPTimeOut.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{preOPTimeOutEntity.anaesthesiologist ? preOPTimeOutEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOPTimeOut.surgeon">Surgeon</Translate>
          </dt>
          <dd>{preOPTimeOutEntity.surgeon ? preOPTimeOutEntity.surgeon.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOPTimeOut.scrubNurse">Scrub Nurse</Translate>
          </dt>
          <dd>{preOPTimeOutEntity.scrubNurse ? preOPTimeOutEntity.scrubNurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-time-out" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-time-out/${preOPTimeOutEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOPTimeOutDetail;
